import { IsDefined, IsNumber, IsOptional, IsString, Length, Matches } from 'class-validator';
import { BaseDto } from '../base.dto';
import { validationPatterns } from '../../constants';

export class BankingSafeCountHeaderDto extends BaseDto {
  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  note: string;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  totalValue: number
}
